import { type LayoutPages } from '../types';
import EmbeddedInitPage from './EmbeddedInitPage';
import EmbeddedAuthPage from './EmbeddedAuthPage';
import EmbeddedWaitingPage from './EmbeddedWaitingPage';
import EmbeddedAgentStartPage from './EmbeddedAgentStartPage';
import EmbeddedAppPairingPage from './EmbeddedAppPairingPage';
import EmbeddedAppPresentationPage from './EmbeddedAppPresentationPage';
import EmbeddedDonePage from './EmbeddedDonePage';
import EmbeddedAbortPage from './EmbeddedAbortPage';
import EmbeddedAppPickerPage from './EmbeddedAppPickerPage';
import EmbeddedIssuanceReviewPage from './EmbeddedIssuanceReviewPage';
import EmbeddedAppInstallPage from './EmbeddedAppInstallPage';

export const embeddedPages: LayoutPages = {
  Init: EmbeddedInitPage,
  Auth: EmbeddedAuthPage,
  WaitingForPresentation: EmbeddedWaitingPage,
  AgentStart: EmbeddedAgentStartPage,
  AppPairing: EmbeddedAppPairingPage,
  AppPresentation: EmbeddedAppPresentationPage,
  Done: EmbeddedDonePage,
  Abort: EmbeddedAbortPage,
  AppPicker: EmbeddedAppPickerPage,
  IssuanceReview: EmbeddedIssuanceReviewPage,
  AppInstall: EmbeddedAppInstallPage,
};

export { default as EmbeddedAppPickerPage } from './EmbeddedAppPickerPage';
export { default as EmbeddedIssuanceReviewPage } from './EmbeddedIssuanceReviewPage';
export { default as EmbeddedAppInstallPage } from './EmbeddedAppInstallPage';
